import classes from "./RuledTable.module.css";

interface Props {
  columns: { label: string; flex: number }[];
  rows: number;
}

/**
 * Ruled write-in table: a header row over N blank rows that divide the remaining
 * height evenly.
 *
 * Not the shared Table component: that hardcodes a 3px bottom border and is used
 * by the Testing Schedule, Performance and Auxiliary pages, so restyling it to
 * this 1px rule would regress them.
 */
const RuledTable = ({ columns, rows }: Props): JSX.Element => (
  <div className={classes.table}>
    <div className={classes.headRow}>
      {columns.map((column) => (
        <div
          key={column.label}
          className={classes.headCell}
          style={{ flex: `${column.flex} 1 0` }}
        >
          {column.label}
        </div>
      ))}
    </div>

    <div className={classes.body}>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <div className={classes.bodyRow} key={rowIndex}>
          {columns.map((column) => (
            <div
              key={column.label}
              className={classes.bodyCell}
              style={{ flex: `${column.flex} 1 0` }}
            />
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default RuledTable;
